import { Injectable } from '@angular/core';

@Injectable()
export class GlobalService {
  private domain: Array<string> = ['mypaymash.com', 'localhost'];

  get companyUuid() {
    /*
     * This method need only for getting uuid from url for paymash domain.
     * This method used only in company effect
     * */
    return location.pathname.split('/')[1];
  }

  get customDomain() {
    return location.hostname;
  }

  get hasCustomDomain() {
    return !this.domain.some((item) => location.hostname.includes(item));
  }

  public redirectToSelfOrdering(companyUuid: string, storeUuid: string) {
    if (this.hasCustomDomain) {
      window.location.href = `${window.location.origin}/menu?storeUuid=${storeUuid}`;
    } else {
      window.location.href = `${window.location.origin}/${companyUuid}/menu?storeUuid=${storeUuid}`;
    }
  }
}
